import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import isBetween from 'dayjs/plugin/isBetween';
import objectSupport from 'dayjs/plugin/objectSupport';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';

dayjs.extend(customParseFormat);
dayjs.extend(duration);
dayjs.extend(isBetween);
dayjs.extend(objectSupport);
dayjs.extend(relativeTime);
dayjs.extend(utc);

/**
 * Returns a Dayjs instance using the current date/time.
 *
 * @returns {Dayjs} Dayjs instance
 */
function now() {
  return dayjs();
}

/**
 * Returns a Dayjs object using the start of today's date.
 *
 * @returns {Dayjs}
 */
function todayStart() {
  return dayjs().startOf('day');
}

/**
 * Returns a Dayjs object using the end of today's date.
 *
 * @returns {Dayjs}
 */
function todayEnd() {
  return dayjs().endOf('day');
}

function makeFriendlyTimestamp(timestamp) {
  let dateString;

  if (!timestamp) {
    return timestamp;
  }

  if (!dayjs.isDayjs(timestamp)) {
    timestamp = dayjs(timestamp);
  }

  const today = dayjs();

  if (timestamp.isSame(today, 'day')) {
    dateString = 'Today';
  } else if (today.subtract(1, 'day').isSame(timestamp, 'day')) {
    dateString = 'Yesterday';
  } else {
    dateString = timestamp.format('M/D/YYYY');
  }

  return `${dateString} ${timestamp.format('h:mm A')}`;
}

export { dayjs, makeFriendlyTimestamp, now, todayStart, todayEnd };
